var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.8 12.88c-2.2 0-2.87-2.9-3.52-5.7-.47-2-1.06-4.56-2.08-4.56S2.42 5.17 1.9 7v.13H.32l.08-.28C1.18 4 2 1.12 4.2 1.12S7.09 4 7.74 6.84c.46 2 1 4.54 2.06 4.54S11.52 8.82 12 7v-.12h1.55l-.12.41C12.75 10 12 12.88 9.8 12.88Z"
})));
export default SvgSine;